/**
 * 推荐模型映射表
 */

// 大家都在搜相关模型
export const HOT_SEARCH = {
  PREFIX: "hot-search-",
  QQ_ANDROID: "hot-search-qq-android",
  QQ_IOS: "hot-search-qq-ios",
  WX_ANDROID: "hot-search-wx-android",
  WX_IOS: "hot-search-wx-ios",
  OLD_HOT_SEARCH: "enter_hot_search"
}

// 用户输入时的模型
export const SEARCH = {
  // 新的搜索
  SEARCH_NEW: "enter_search_new",
  // 搜索游戏
  SEARCH_GAME: "enter_search_game"
}

export const SERVICE_ZONE = {
  WZRY_SMALL_ZONE: "activity_recomm",
  WZRY_KEYWORD_DAOJU_SEARCH: "wzry_zq_props_search",
  WZRY_KEYWORD_NEWS_SEARCH: "wzry_zq_news_search",
  WZRY_NEWS_BY_NEWS: "wzry_news_tag_recomm_by_news",
  WZRY_NEWS_BY_HERO: "wzry_hero_news_tag_recommend",
  WZRY_NEWS_BY_HERO_PAGINATION: "wzry_hero_news_tag_recomm_pagination",
  WZRY_VID: "wzry_vid_tag_recomm",
  WZRY_HOT_RECOMM: "wzry_servicezone_hot_recomm",
  WZRY_HOT_RECOMM_ID: "21271-21272-22271-22272",
  WZRY_FRIENDS_HERO_NUMBER: "wzry_thumbs_up_yx_friends",
  WZRY_FRIENDS_SKIN_NUMBER: "wzry_thumbs_up_pf_friends",

  GAME_ZONE_LIST_HOT: "game_list_hot"
}

// IpZone相关
export const IP_ZONE = {
  // 专区顺序
  IP_ZONE_SORT: "store_zone_sort_recomm",
  // 会员钻列表页专区
  VIP_LIST_IP_ZONE: "ipzone_viplist_recommen"
}

// 新游预约相关
export const GAME_RESERVATION = {
  RECOMMEND_SORT: "servicezone_reservation"
}

export const INDEX_MALL = {
  // 是否是广场白名单用户
  IN_WZRY_WHITE_LIST: "index_mall_wzry_whitelist",
  // 好店铺推荐
  RECOMMEND_SHOPS: "index_mall_recommend_shops",
  // 好物推荐
  RECOMMEND_GOODS: "index_mall_recommend_goods",
  // 王者荣耀好物推荐
  RECOMMEND_WZRY_GOODS: "wzry_servicezone_recomm_and_activity",
  // 非王者荣耀游戏好物推荐集合接口
  RECOMMEND_GAME_GOODS: "index_mall_recommend_hot"
}

// 支付相关
export const PAY = {
  PAY_GROUPID: "user_pay_group"
}
